import React, { useState, useEffect, Fragment } from 'react';
import { syncPartnerTexts, loadPartnerTexts, savePartnerTexts, checkPartnerIntegration, deletePartnerIntegration, resetPartnerErrors } from '../../modules/partners'
import { activatePartnerIntegration } from '../../modules/appIntegrations';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../components/OptionsMenu';
import NewFlexItemList from '../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import Collapse from '@mui/material/Collapse';
import { Alert, AlertTitle } from '@mui/material';
import { Trans, withTranslation, useTranslation } from 'react-i18next';


import ExportImportDialogs from '../../components/ExportImportDialogs';
import { _clearUnchangedFields, _getValidationPropsFromValidations } from '../../helper';
import API from '../../api/api';
import { FilterOptionsSelect, FilterOptionsQuery, FilterOptionsSort } from '../../components/ItemsListFilterOptions';

class AppIntegration extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      partnerTexts: [],
      errorLockCollapse: false,
      initialItem: null
    }
  }

  componentDidMount() {
    console.log(this.props.match.params.id);
    //this.props.syncPartnerTexts(this.props.match.params.id, this.props.editLanguage, true, () => {});
    //this.props.checkPartnerIntegration(this.props.match.params.id);
    this.props.activatePartnerIntegration(this.props.match.params.id);
    this.props.syncPartnerTexts(this.props.match.params.id, this.props.editLanguage);
    // this.props.loadPartnerTexts(this.props.match.params.id, this.props.editLanguage);
  }

  componentDidUpdate(prevProps) {
    // Check if URL param id or editLanguage changed
    if (
      this.props.match.params.id !== prevProps.match.params.id ||
      this.props.editLanguage !== prevProps.editLanguage
    ) {
      this.props.loadPartnerTexts(this.props.match.params.id, this.props.editLanguage);
    }
    
    /*
    if (this.props.editTheme !== prevProps.editTheme) {
      this.props.loadAppEmbeds(this.props.editTheme, true);

      // Deeplinking
      let id = this.props.location.pathname.split("apps/")[1];
      if(id) {

        //this.props.loadAppEmbed(id, this.props.editLanguage);
        this.setState({
          initialItem: id
        })
      }
    }
    */
  }

  componentWillReceiveProps(newProps) {
    const { t } = this.props;
  
    if (
      (this.props.partners?.load_partner_texts_pending === true && newProps.partners?.load_partner_texts_pending === false) ||
      (this.props.partners?.sync_partner_texts_pending === true && newProps.partners?.sync_partner_texts_pending === false) ||
      (this.props.partners?.save_partner_texts_pending === true && newProps.partners?.save_partner_texts_pending === false)
    ) {
      const sectionMap = {};
  
      if (newProps.partners.partner_texts && newProps.partners.partner_texts.length > 0) {
        newProps.partners.partner_texts.forEach(item => {


          // Determine section name
          const rawSection = Array.isArray(item.path) ? item.path[0] : item.path;
          const section = rawSection ? rawSection.split('.')[0] : 'unknown';
  
          if (!sectionMap[section]) {
            sectionMap[section] = {
              type: 'appEmbed',
              id: section, 
              gid: item.gid,
              progress: !item.progress ? -1 : item.progress,
              synchronized: item.synchronized,
              title: section.charAt(0).toUpperCase() + section.slice(1),
              info: '',
              hasError: item.hasError,
              fields: []
            };
          }
  
          if (!sectionMap[section].fields.some(x => (x.id === item.path || x.id === item.path[0]))) {
              sectionMap[section].fields.push({
                id: item.id || Array.isArray(item.path) ? item.path[0] : item.path,
                bogos_id: item.bogos_id,
                type: 'text',
                label: Array.isArray(item.path) ? item.path[0] : item.path,
                source: item.source,
                target: item.target === null ? '' : item.target,
                error: item.error,
                restore: item.restore,
            });
          }
        });
  
        // Convert sectionMap to array
        const newPartnerTexts = Object.values(sectionMap);

        console.log('-----');
        console.log(newProps.partners.partner_texts);
        console.log(newPartnerTexts);
  
        this.setState({ partnerTexts: newPartnerTexts });
      }
    }
  }

  onCollapsed = (id) => {}

  onSave = items => {
    const usedItems = [];
  
    items.forEach(item => {
      item.fields.forEach(field => {
        usedItems.push({
          source: field.source,
          bogos_id: field.bogos_id,
          id: field.id,
          target: field.target || '' // laut API "" oder null = löschen
        });
      });
    });
  
    console.log(usedItems);
  
    this.props.savePartnerTexts(
      this.props.match.params.id,
      this.props.editLanguage,
      usedItems, // <--- jetzt korrektes Format
      res => {}
    );
  }

  render() {
    const { t } = this.props;

    let appTitle;
    try {
      appTitle = this.props.appIntegrations.partners.find(x => x.slug === this.props.match.params.id).title;
      console.log(appTitle)
    } catch {}

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('navigation.primary.apps')}
        {appTitle &&
          <Fragment>
            <ChevronRightIcon />
            {appTitle}
          </Fragment>
        }
      </Typography>

      <Divider className="divider-white" />

      <ItemsList 
        virtualized={true}
        type="apps"
        extraRouteSegment={this.props.match.params.id}
        //useLazyloading
        //loadMoreButton={this.props.partners.cursor}
        //onLoadMore={this.onLoadMore}
        //filterModules={null}
        pagination={false}
        paginate={false}
        onCollapsed={this.onCollapsed}
        isPending={
          this.props.partners.load_partner_texts_pending ||
          this.props.partners.sync_partner_texts_pending ||
          this.props.partners.save_partner_texts_pending
        }
        isSaving={
          this.props.partners.save_partner_texts_pending
        }
        onSave={this.onSave}
        data={this.state.partnerTexts}
        allowAutoTranslation={true}
        error={this.props.partners.error}
        errorLockCollapse={this.state.errorLockCollapse}
        saveErrors={this.props.partners.saveErrors}
        emptyMessage={
          (this.props.partners.load_partner_texts_pending === false && this.props.partners.sync_partner_texts_pending === false && this.state.partnerTexts.length === 0) ? 
          <EmptyView 
            title={'No translation fields available'}
          />
        :
          <ItemsListSkeleton rows={5} />
        }
      />
      <LoadingIndicator
        pending={
          this.props.partners.load_partner_texts_pending || 
          this.props.partners.sync_partner_texts_pending || 
          this.props.partners.save_partner_texts_pending
        }
        loadingType={this.props.partners.save_partner_texts_pending ? 'saving' : 'loading'}
        progress={(this.props.partners.progress < 0) ? 0 : this.props.partners.progress}
        error={this.props.partners.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />
    </React.Fragment> 
  }
}


const mapStateToProps = ({ partners, appIntegrations, shop, themes }) => ({
  appIntegrations: appIntegrations,
  partners: partners,
  partnerTexts: partners.partner_texts,
  editLanguage: shop.shop.edit_language,
  themes: themes,
  editTheme: themes.edit_theme,
  shopUrl: shop.shop.url,
  shopPlan: shop.shop.charge.name,
  shop: shop.shop
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncPartnerTexts,
      loadPartnerTexts,
      savePartnerTexts,
      activatePartnerIntegration,
      //checkPartnerIntegration,
      //deletePartnerIntegration,
      resetPartnerErrors
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AppIntegration)))
